import { api } from "./api";
import { AxiosError } from "axios";
import type {
  WorkSessionResponse,
  WorkSessionsResponse,
} from "@/types/workSession.type";

// Récupère les sessions de travail avec filtres optionnels
export const getWorkSessions = async (params?: {
  userId?: string;
  companyId?: string;
  startDate?: string;
  endDate?: string;
  page?: number;
  limit?: number;
  groupBy?: string;
  search?: string;
  active?: boolean;
  hasComment?: boolean;
  isReviewed?: boolean;
}) => {
  try {
    const response = await api.get<WorkSessionsResponse>("/work-sessions", {
      params,
    });
    return response.data;
  } catch (error: unknown) {
    if (error instanceof AxiosError) {
      throw new Error(
        error.response?.data?.message ||
        "Erreur lors de la récupération des sessions de travail"
      );
    }
    throw new Error("Erreur lors de la récupération des sessions de travail");
  }
};

// Modifier une session de travail
export const updateWorkSession = async (
  id: string,
  data: {
    startTime?: string;
    endTime?: string | null;
    isReviewed?: boolean;
  }
) => {
  try {
    const response = await api.patch<WorkSessionResponse>(
      `/work-sessions/${id}`,
      data
    );
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      throw new Error(
        error.response?.data?.message ||
        "Erreur lors de la mise à jour de la session"
      );
    }
  }
};

// Créer une session de travail manuellement
export const createWorkSession = async (data: {
  employeeId: string;
  startTime: string;
  endTime?: string | null;
  companyId?: string;
}) => {
  try {
    const response = await api.post<WorkSessionResponse>(
      "/work-sessions",
      data
    );
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      throw new Error(
        error.response?.data?.message ||
        "Erreur lors de la création de la session de travail"
      );
    }
    throw new Error("Erreur lors de la création de la session de travail");
  }
};

// Supprimer une session de travail
export const deleteWorkSession = async (id: string) => {
  try {
    const response = await api.delete(`/work-sessions/${id}`);
    return response.data;
  } catch (error: unknown) {
    if (error instanceof AxiosError) {
      throw new Error(
        error.response?.data?.message ||
        "Erreur lors de la suppression de la session de travail"
      );
    }
    throw new Error("Erreur lors de la suppression de la session de travail");
  }
};
